/* eslint-disable import/first */
import React, { useEffect, useState, useCallback } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { useNavigate, useLocation } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';
import { Button, Grid, Paper, TextField, Typography, IconButton } from '@material-ui/core';
import { Check } from '../../components/Icons';
const { getQRValue, selectDesktop } = Slices.appSlice;
const {
  selectLoginStatus,
  logout,
  selectProfileStatus,
  createProfile,
  loginGuest,
} = Slices.authSlice;
import Header from '../../components/Header';
import LanguageButton from '../../components/LanguageButton';
import { MobileNumberInput } from '../Profile/MobileNumberInput';
const { getCurrentProfile, getProfile, selectCurrentCountry, isMultiCountry } = Slices.profileSlice;
import { FaArrowLeft } from '@react-icons/all-files/fa/FaArrowLeft';
import { MdErrorOutline } from '@react-icons/all-files/md/MdErrorOutline';
import {
  signupAttemptGA,
  signupFailureGA,
  signupSuccessGA,
} from 'spwa-ui-library/esm/utils/helperGA';
import { createMuiTheme, jssPreset, ThemeProvider, StylesProvider } from '@material-ui/core/styles';
import { create } from 'jss';
import Cookies from 'js-cookie';
import rtl from 'jss-rtl';
import css from './index.module.scss';
import PHBackButton from '../../components/PHBackButton';
const { selectCountryValidations } = Slices.configSlice;

function CreateProfile({ path, locale }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const intl = useIntl();
  // const profile = useSelector((state) => state.profile);
  // eslint:fix profile is defined a value but is never used
  const draftProfile = useSelector(getCurrentProfile);

  const isMultiCountryProfile = useSelector(isMultiCountry);
  const loginQR = useSelector(getQRValue);
  const isLoggedIn = useSelector(selectLoginStatus);
  const isProfileCreated = useSelector(selectProfileStatus);
  const { mobile, retUrl = '' } = location.state || {};
  const [name, setName] = useState('');

  const [phnNo, setPhnNo] = useState(mobile);
  const [email, setEmail] = useState('');
  // const [dialogState, setDialogState] = useState(true);
  // eslint:fix
  const [errorBool, setErrBool] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [nameError, setNameError] = useState(false);
  const countryName = useSelector(selectCurrentCountry);

  const countryValidations = useSelector((state) => selectCountryValidations(state, countryName));
  const [cCode, setcCode] = useState(countryValidations?.defaultCCode);
  const [msg, setMsg] = useState('');
  const isDesktop = useSelector(selectDesktop);
  // let a;
  React.useEffect(() => {
    setPhnNo((prev) => draftProfile?.phnNo);
    setName((prev) => draftProfile?.name);
    setEmail((prev) => draftProfile?.email);
    setcCode((old) => countryValidations?.defaultCCode);
  }, [countryValidations.defaultCCode, draftProfile]);
  // const handleClose = () => {
  //   setDialogState(false);
  //   dispatch(logout());
  //   navigate(`/${intl.locale}/login`);
  // };
  // eslint:fix handleClose is defined but is never used
  useEffect(() => {
    signupAttemptGA(loginQR);
  }, [loginQR]);
  const handleNameInput = (e) => {
    setName(e.target.value.replace(/[^a-zA-Z ]/g, ''));
    validationName(e.target.value.replace(/[^a-zA-Z ]/g, ''));
  };
  const handlePhoneInput = (e) => {
    setPhnNo(e.target.value);
  };
  const validationEmail = (emailInput) => {
    let email = emailInput;
    let pattern = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/g;
    if (email.match(pattern)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }

    if (email === '') {
      setEmailError(true);
    }
  };
  const validationName = (nameInput) => {
    let name = nameInput;
    var pattern = /^(?:[a-zA-Z\s\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDCF\uFDF0-\uFDFF\uFE70-\uFEFF]|(?:\uD802[\uDE60-\uDE9F]|\uD83B[\uDE00-\uDEFF]))/;
    if (name.match(pattern)) {
      setNameError(false);
    } else {
      setNameError(true);
    }

    if (name === '') {
      setNameError(true);
    }
  };

  const handleEmailInput = (e) => {
    const { value } = e.target;
    setEmail(value);
    validationEmail(value);
  };
  const handleCreateProfile = (e) => {
    const phone = phnNo.replace(cCode, '');

    dispatch(
      createProfile({
        cCode,
        createProfileVia: 'OTP',
        phnNo: phone,
        email,
        name,
        isGuest: 0,
      })
    )
      .then((resp) => {
        if (resp.payload?.data.type === 'LOGIN') {
          dispatch(getProfile());
          if (retUrl !== '') {
            // debugger;
            const retURL = isDesktop
              ? location?.state?.oldLocation?.pathname || `/${intl.locale}${retUrl}`
              : `/${intl.locale}${retUrl}`;
            navigate(retURL, { replace: true });
          } else {
            // debugger;
            const retURL = isDesktop
              ? location?.state?.oldLocation?.pathname || `/${intl.locale}/home`
              : `/${intl.locale}/home`;
            navigate(retURL, { replace: true });
          }
          signupSuccessGA(loginQR, resp.payload?.data.data);
        } else if (resp.payload?.data.type === 'USER_EMAIL_ALREADY_EXIST') {
          setErrBool(true);
          setMsg(resp.payload.data.message);
          signupSuccessGA(loginQR);
        } else if (resp.error?.message) {
          setErrBool(true);
          setMsg(resp.error.message);
          signupFailureGA(loginQR);
        }
      })
      .catch((err) => {
        setErrBool(true);
        setMsg(err.payload.message);
      });
  };

  useEffect(() => {
    if (!isLoggedIn) {
      // navigate(retUrl);
    }
    if (isLoggedIn && isProfileCreated) {
      navigate(`${intl.locale}/home`);
    }
  }, [intl.locale, isLoggedIn, isProfileCreated, navigate]);

  const onExitMemoized = useCallback(
    (e) => {
      if (!isMultiCountryProfile) {
        dispatch(logout()).then((respBack) => {
          dispatch(loginGuest()).then((resp) => {
            dispatch(getProfile());
          });
        });

        navigate(`/${intl.locale}/login`);
      } else {
        navigate(-1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  const ltrTheme = createMuiTheme({ direction: 'ltr' });
  const rtlTheme = createMuiTheme({ direction: 'rtl' });
  const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
  const [isRtl] = React.useState(Cookies.get('local') === 'ar' ? rtlTheme : ltrTheme);

  return (
    <main className={css.root}>
      <div className={css.backButton}>
        <PHBackButton onclick={onExitMemoized} />
      </div>

      <Grid className={css.headerContainer}>
        <Grid className={css.headerText}>
          <Typography>
            <FormattedMessage id="create" defaultMessage="Create" />
          </Typography>
        </Grid>
        <Grid className={css.headerText + ' ' + css.boldText}>
          <Typography>
            <FormattedMessage id="yourProfile" defaultMessage="Your Profile" />
          </Typography>
        </Grid>
        <span className={css.secondaryText}>
          <FormattedMessage
            id="createprofile_enterdetails"
            defaultMessage={`Please enter your details`}
          />
        </span>
      </Grid>
      <Paper>
        <StylesProvider jss={jss}>
          <ThemeProvider theme={isRtl}>
            <Grid className={css.profileCardArea}>
              <Grid className={css.inputArea}>
                <>
                  <input
                    // label={<FormattedMessage id="nameCaps" defaultMessage="NAME" />}
                    placeholder={intl.formatMessage({ id: 'nameCaps' })}
                    className={css.nameField}
                    required
                    fullWidth
                    value={name}
                    // type="text"
                    onChange={handleNameInput}
                    // InputLabelProps={{
                    //   shrink: false
                    // }}
                    InputProps={{ disableUnderline: true, maxLength: 40 }}
                  />
                </>
              </Grid>
              <div className={css.errorMessage}>
                {!nameError ? null : (
                  <div className={css.errorIcon}>
                    <FormattedMessage
                      id="name_validate"
                      defaultMessage="Please Enter a valid Name"
                    />
                  </div>
                )}
              </div>

              <Grid className={css.inputArea}>
                <input
                  placeholder={intl.formatMessage({ id: 'emailUpper' })}
                  className={css.emailField}
                  required
                  fullWidth
                  value={email}
                  disabled={draftProfile?.emailVerified || 0}
                  onChange={handleEmailInput}
                  type="email"
                  InputProps={{ disableUnderline: true }}
                />
                {draftProfile?.emailVerified ? (
                  <div className={css.check}>
                    <Check />
                  </div>
                ) : (
                  ''
                )}
              </Grid>
              <div className={css.errorMessage}>
                {!emailError ? null : (
                  <div className={css.errorIcon}>
                    <FormattedMessage
                      id="email_validate"
                      defaultMessage="Please Enter a valid Email"
                    />
                  </div>
                )}
              </div>
              <Grid className={css.mobileInput}>
                <MobileNumberInput
                  showCountryDropDown={false}
                  countryCode={countryValidations?.defaultCCode}
                  value={phnNo}
                  onChange={handlePhoneInput}
                  phoneVerified={draftProfile?.phnVerified ? 1 : 0}
                  page="create-profile"
                  verifiedEmail={email}
                  placeholder
                  disableButton={'correct'}
                />
              </Grid>
              {errorBool && (
                <div className={css.errorEmail}>
                  <div className={css.errorIcon}>
                    <MdErrorOutline size={20} />
                  </div>
                  {msg}
                </div>
              )}
              <Grid className={css.buttonArea}>
                <Button
                  style={{ width: '100%' }}
                  variant="contained"
                  color="primary"
                  onClick={handleCreateProfile}
                  className={`${css.button} ${
                    email === '' || emailError || nameError || name === '' ? css.disabledButton : ''
                  }`}
                  disabled={
                    email === '' ||
                    emailError ||
                    nameError ||
                    name === '' ||
                    phnNo == '' ||
                    !phnNo?.match(countryValidations?.phnRegex)
                  }
                >
                  <FormattedMessage id="guest_save" defaultMessage="Continue" />
                </Button>
              </Grid>
            </Grid>
          </ThemeProvider>
        </StylesProvider>
      </Paper>
    </main>
  );
}

export default CreateProfile;
